/**
 * `@turbodocx/html-to-docx` gives every top-level node its own paragraph, so the
 * hoisted `<sup>1</sup>` renders on a line by itself. This function pulls any
 * loose `<sup>`s back inside the preceding block so they stay inline
 */
const looseSupRegex = /<\/(p|li|h[1-6])>(\s*(?:<sup\b[^>]*>[^<]*<\/sup>\s*)+)/g

export const wrapLooseReferenceSups = (html: string): string =>
  html.replace(looseSupRegex, (_match, blockTag: string, sups: string) => {
    const trimmedSups = sups.trim()
    return `${trimmedSups}</${blockTag}>`
  })
